import React, { useEffect, useState } from "react";
import PageTitle from "../../Components/PageTitle/PageTitle";
import AssetPath from "../../AssetPath/AssetPath";
import apiClient from "../../Actions/apiClient";
import AgendaList from "./AgendaList";

export default function Agenda() {
  const [upcomingEvents, setUpcomingEvents] = useState([]);

  useEffect(() => {
    apiClient.get("events/list").then(({ data }) => {
      if (data && data.result) {
        const upcoming = data.result
          .filter((event) => event.eventType === "UpcomingEvents")
          .sort(
            (a, b) => new Date(a.eventDateStart) - new Date(b.eventDateStart),
          );
        setUpcomingEvents(upcoming);
      }
    });
  }, []);

  return (
    <>
      <PageTitle
        mainTitle="Agenda"
        breadcrumbItems={[{ name: "Agenda", path: "/agenda" }]}
        image={AssetPath.breadcrumb.pastEvents}
      />
      {upcomingEvents.length === 0 && (
        <section className="faq agenda spacing" data-aos="fade-up">
          <div className="container">
            <div className="text-center mt-3">
              <h4 className="title mb-2 text-primary fw-bold">Agenda</h4>
            </div>

            <h4 className="text-primary text-center fst-italic mb-1">
              Coming Soon
            </h4>
          </div>
        </section>
      )}

      {/* Display all upcoming events agendas */}
      {upcomingEvents.map((event) => (
        <AgendaList key={event._id || event.id} title={event.title} />
      ))}
    </>
  );
}
